import { ProfilesClient, ProfileMaterialConfigurationRequest, ProfileCreateUpdateResponse, NodeMaterialConfigurationDto } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const profilesClient = new ProfilesClient(undefined, axios);

// Hook to get profile material configuration
export const useProfileMaterialConfiguration = (profileId: number, options?: any) => {
  return useQuery<NodeMaterialConfigurationDto[]>({
    ...options,
    queryKey: ["profileMaterialConfiguration", profileId],
    queryFn: async () => {
      return await profilesClient.getProfileConfiguration(profileId.toString());
    },
    enabled: !!profileId,
  });
};

// Hook to save profile material configuration
export const useSaveProfileMaterialConfiguration = () => {
  return useMutation<ProfileCreateUpdateResponse, Error, ProfileMaterialConfigurationRequest>({
    mutationFn: async (request: ProfileMaterialConfigurationRequest) => {
      // Create the API request object

      return await profilesClient.saveProfileMaterialConfiguration(
        request.profileId as string,
        request
      );
    },
    onSuccess: ( variables) => {
      // Invalidate and refetch the specific profile configuration
      queryClient.invalidateQueries({ 
        queryKey: ["profileMaterialConfiguration", parseInt(variables.profileResponse?.profileId || "0")] 
      });
      // Also invalidate profile details in case we need to refresh the main grid
      queryClient.invalidateQueries({ 
        queryKey: ["profileDetails"] 
      });
    },
    onError: (error) => {
      console.error('Error saving profile material configuration:', error);
    },
  });
};